import SearchContext from 'contexts/SearchContext';
import { MalaPuscicaDesno, MalaPuscicaLevo } from 'kzv-icons';
import React, { useContext } from 'react';
import ReactPaginate from 'react-paginate';
import { Mixpanel } from 'utils/Mixpanel';
import IconButton from '../buttons/IconButton';
import { setPage } from 'contexts/SearchActions';

function SearchPagination() {
    const { state, dispatch } = useContext(SearchContext);

    const handlePageChange = (page) => {
        setPage(dispatch, page.selected + 1);
        Mixpanel.track('Search page change', {
            page: page.selected + 1
        });
    };
    return (
        <>
            {state?.results?.data?.length > 0 && state?.results?.meta?.last_page > 1 && (
                <ReactPaginate
                    pageCount={state.results.meta.last_page}
                    forcePage={state.results.meta.current_page - 1}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    previousLabel={
                        <IconButton>
                            <MalaPuscicaLevo strokeWidth={1.3} />
                        </IconButton>
                    }
                    nextLabel={
                        <IconButton>
                            <MalaPuscicaDesno strokeWidth={1.3} />
                        </IconButton>
                    }
                    containerClassName="flex items-center justify-center gap-2 md:gap-3"
                    breakClassName="text-gray-600"
                    pageLinkClassName="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center text-center text-sm"
                    activeLinkClassName="bg-brand text-white pointer-events-none"
                    disabledClassName="opacity-50 pointer-events-none"
                    onPageChange={handlePageChange}
                    disableInitialCallback
                />
            )}
        </>
    );
}

export default SearchPagination;
